import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import vueHeadful from 'vue-headful';
import VueScrollTo from 'vue-scrollto';
import Vuetify from 'vuetify';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VeeValidate from 'vee-validate';

import Api from './api';
import Router from './router';
import Store from './store';
import App from './App.vue';

import './registerServiceWorker';

// import styles
import './styles/global.scss';

Api.init(Router, Store);
Vue.use(Vuetify);
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_KEY });
Vue.use(VeeValidate);
Vue.use(VueScrollTo);
Vue.component('vue-headful', vueHeadful);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router: Router,
  store: Store,
}).$mount('#app');
